import escape from 'cio/utils/escape';

export let padNumber = function (number) {
  number = parseInt(number);

  if (number < 10) {
    return `0${number}`;
  }
  return number;
};

export let seriesString = function (list, delimiter = ',', prefix = '', suffix = '', conjunction = 'and') {
  let items = list.split(delimiter);
  let formattedItems = items.map((item) => prefix + escape(item.trim()) + suffix);
  let { length } = formattedItems;

  if (length > 1) {
    formattedItems[length - 2] += ` ${conjunction} ${formattedItems.pop()}`;
  }

  return formattedItems.join(', ');
};

export let compactNumber = function (number, options = {}) {
  if (isNaN(number)) {
    return '--';
  }
  try {
    // This is a namespace not a constructor and can't be instantiated with `new`
    /* eslint-disable  new-cap */
    return Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumFractionDigits: 10,
      ...options,
    }).format(number);
  } catch (error) {
    return number;
  }
};
